'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  VIMEO: null,
  SOUNDCLOUD: null
});


/** WEBPACK FOOTER **
 ** ./constants/MediaSources.js
 **/